import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'https://codelens.epoch.co/openshield/';

class AlertsApiService {
  constructor() {
    this.api = axios.create({
      baseURL: API_BASE_URL,
      timeout: 30000,
      headers: {
        'Content-Type': 'application/json',
      },
    });

    // Add request interceptor for Cognito token authentication
    this.api.interceptors.request.use(
      (config) => {
        const accessToken = localStorage.getItem('cognito_token');
        if (accessToken) {
          config.headers.Authorization = `Bearer ${accessToken}`;
        } else {
          // If no token, reject the request
          return Promise.reject(new Error('No authentication token available'));
        }
        return config;
      },
      (error) => Promise.reject(error)
    );

    // Add response interceptor for error handling
    this.api.interceptors.response.use(
      (response) => response,
      (error) => {
        if (error.response?.status === 401) {
          localStorage.removeItem('cognito_token');
          localStorage.removeItem('user_info');
          window.location.href = 'https://codelens.epoch.co/';
        }
        return Promise.reject(error);
      }
    );
  }

  /**
   * Fetch all alerts from the compliance backend
   * @param {Object} params - Query parameters (page, size, etc.)
   * @returns {Promise<Object>} Alerts response object with pagination
   */
  async getAllAlerts(params = {}) {
    try {
      const response = await this.api.get('/alerts/', { params });
      return response.data;
    } catch (error) {
      console.error('Error fetching alerts:', error);
      throw error;
    }
  }

  /**
   * Fetch alerts for a specific agent
   * @param {string} agentId - The agent ID to fetch alerts for
   * @param {Object} params - Query parameters (page, size, etc.)
   * @returns {Promise<Object>} Alerts response object with pagination
   */
  async getAlertsByAgent(agentId, params = {}) {
    try {
      const response = await this.api.get(`/alerts/${agentId}`, { params });
      return response.data;
    } catch (error) {
      console.error(`Error fetching alerts for agent ${agentId}:`, error);
      throw error;
    }
  }
}

// Create and export a singleton instance
const alertsApiService = new AlertsApiService();
export default alertsApiService;
